/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDataLocationAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 3a1 1 0 0 1 1-1h6.001A3.99 3.99 0 0 1 12 3.354 3.99 3.99 0 0 1 14.999 2H21a1 1 0 0 1 1 1v8.57a5.706 5.706 0 0 0-2-.549V4h-5.001A2 2 0 0 0 13 5.999v11.535c.321-.186.67-.328 1.04-.42a5.89 5.89 0 0 0 .534 1.851l.035.072A1.999 1.999 0 0 0 13 21a1 1 0 1 1-2 0c0-1.106-.894-2-2-2H3a1 1 0 0 1-1-1zm9 14.534V5.999A2 2 0 0 0 9.001 4H4v12.999h5c.729 0 1.412.195 2 .535z" />
        <path d="M21.525 13.64a3.517 3.517 0 0 0-4.05 0c-1.447 1.013-1.855 3.034-1.11 4.67.464 1.017 1.369 2.556 3.135 4.69 1.766-2.134 2.67-3.673 3.135-4.69.745-1.636.337-3.657-1.11-4.67zM21 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgDataLocationAlt as DataLocationAlt };
